import { AppErrorCode, Context, PaginatedResult, enumMapToSame, isAppError, mapDtoToEntity } from '../../../common'
import { Api, HttpClient, SalesPointsApi } from '../../../api'
import {
  AddSalesPointOpts,
  SalesPoint,
  SalesPointFindOptions,
  SalesPointsService,
  SalesPointType,
  UpdateSalesPointOpts,
} from './salesPoints'

function mapDtoToSalesPoint(dto: Api.SalesPoint): SalesPoint {
  return mapDtoToEntity({
    ...dto,
    type: dto.type ? enumMapToSame<Api.SalesPoint.Type, SalesPointType>(dto.type) : undefined,
  })
}

export class RemoteSalesPointsService implements SalesPointsService {
  private api: SalesPointsApi

  constructor(httpClient: HttpClient) {
    this.api = new SalesPointsApi(httpClient, undefined, '')
  }

  async findAll(ctx: Context, opts?: SalesPointFindOptions | undefined): Promise<PaginatedResult<SalesPoint>> {
    const result = await this.api.salesPointsGetList(ctx, {
      ids: opts?.filter?.ids,
      search: opts?.filter?.search,
      municipalEntityId: opts?.filter?.municipalEntityId,
      withDeleted: opts?.filter?.withDeleted,
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
      orderBy: opts?.order?.field,
      direction: opts?.order?.direction,
    })

    return {
      ...result.body,
      items: result.body.items.map(mapDtoToSalesPoint),
    }
  }

  async findById(ctx: Context, id: string): Promise<SalesPoint | undefined> {
    try {
      const result = await this.api.salesPointGetById(ctx, id)
      return mapDtoToSalesPoint(result.body.object)
    } catch (e) {
      if (isAppError(e) && e.code === AppErrorCode.OBJECT_NOT_FOUND) return
      throw e
    }
  }
  async findByIdNonDeleted(ctx: Context, id: string): Promise<SalesPoint | undefined> {
    const result = await this.api.salesPointsGetList(ctx, { ids: [id] })
    return result.body.items.length > 0 ? mapDtoToSalesPoint(result.body.items[0]) : undefined
  }
  async add(ctx: Context, opts: AddSalesPointOpts): Promise<string> {
    const result = await this.api.salesPointsAdd(ctx, opts)

    return result.body.id
  }
  async update(ctx: Context, id: string, opts: UpdateSalesPointOpts): Promise<void> {
    await this.api.salesPointUpdate(ctx, id, opts)
  }
  async delete(ctx: Context, id: string): Promise<void> {
    await this.api.salesPointDelete(ctx, id)
  }
}
